// https://dev.to/oyetoket/fastest-way-to-generate-random-strings-in-javascript-2k5a
export const generateRandomString = (length = 10) =>
  Math.random().toString(20).substr(2, length);

export const alphabetizeArrayByKey = (array, key) => {
  if (!array || !Array.isArray(array)) return [];

  const sortedArray = array.sort((a, b) => {
    const varA = a?.[key];
    const varB = b?.[key];

    if (varA < varB) return -1;
    if (varA > varB) return 1;

    return 0;
  });

  return sortedArray;
};

export const isMappableArray = (arr) => {
  return Array.isArray(arr) && arr?.length >= 1;
};

export const hexToRgba = (hex, opacity = 1) => {
  // Remove leading "#" if present
  hex = hex.replace(/^#/, "");

  // Handle 3-digit hex (e.g. #f53 → #ff5533)
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  // Parse the red, green, blue values
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  // Return rgba string
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

/*
 * By default, format number with parentheseses ex: (123) 456-7890
 * setting dashesOnly=true will format with all dashes ex: 123-456-7890
 */
export const formatPhoneNumber = (value = "", dashesOnly = false) => {
  if (typeof value !== "string") return "";

  const num = stripNonDigit(value);
  const paren1 = num.length && !dashesOnly ? "(" : "";
  const paren2 = num.length > 3 ? (dashesOnly ? "-" : ") ") : "";
  const dash = num.length > 6 ? "-" : "";

  return (
    paren1 +
    num.substring(0, 3) +
    paren2 +
    num.substring(3, 6) +
    dash +
    num.substring(6, 10)
  );
};

export const typeText = (text = "", speed = 60, index = 0, targetId = "") => {
  const target = document.getElementById(targetId);
  if (!target) return; // safety

  if (index < text.length) {
    target.textContent += text.charAt(index);

    setTimeout(() => {
      typeText(text, speed, index + 1, targetId);
    }, speed);
  }
};

export const getFirstName = (fullName = "") => {
  return fullName.trim().split(" ")[0];
};

export const stripNonDigit = (value = "") => {
  if (typeof value !== "string") return "";
  return value.replace(/\D/g, "");
};

export const replaceHtmlEntities = (str) => {
  if (!str || typeof str !== "string") return;
  return str.replace(/&\S+;/g, (tag) => {
    return tagsToReplace[tag] || str;
  });
};

export const buildAgeRange = (min, max) => {
  return Array.from({ length: max - min + 1 }, (_, i) => {
    const value = min + i;
    return { title: value, value };
  });
};

export const getFormattedDate = (date, options, languageCode) => {
  // readable date no library :) https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
  const newDate = new Date(date);
  const formattedDate = date
    ? new Intl.DateTimeFormat(
        languageCode || "en-US",
        options || { month: "short", day: "numeric", year: "numeric" },
      )?.format(newDate)
    : "";
  return formattedDate;
};

export const formatDate = (value) => {
  if (typeof value !== "string") return "";

  const thisYear = new Date().getFullYear();

  // replace all characters other than numbers
  let num = stripNonDigit(value);
  const firstNumber = parseInt(num[0]);
  if (firstNumber > 1) {
    return "";
  }

  let dash1;
  let dash2;

  if (value.length > 2) {
    dash1 = "/";
  } else {
    dash1 = "";
  }
  if (value.length > 5) {
    dash2 = "/";
  } else {
    dash2 = "";
  }

  const month = num.substring(0, 2);
  const date = num.substring(2, 4);
  const year = num.substring(4, 8);

  let mm = month > 12 ? 12 : month;
  let dd = date > 31 ? 31 : date;
  let yyyy = year > thisYear ? thisYear : year;

  if (mm === "00") {
    mm = "01";
  }

  if (dd === "00") {
    dd = "01";
  }

  if (parseInt(dd[0]) > 3) {
    dd = 3;
  }

  if (year.length && parseInt(yyyy[0]) > parseInt(String(thisYear)[0])) {
    yyyy = String(thisYear)[0];
  }

  if (year.length === 4 && parseInt(yyyy) < parseInt(String(thisYear) - 100)) {
    yyyy = parseInt(String(thisYear) - 100);
  }

  return mm + dash1 + dd + dash2 + yyyy;
};

export const getAgeFromBirthday = (birthdateInput) => {
  const today = new Date();
  const birthdate = new Date(birthdateInput);

  if (birthdate.toString() === "Invalid Date") return false;

  const ageInMs = today - birthdate;
  const ageDate = new Date(ageInMs); // Epoch-based age calculation

  const age = Math.abs(ageDate.getUTCFullYear() - 1970);

  return age;
};

export const getToday = () => {
  const date = new Date();

  return (
    String(date.getMonth() + 1).padStart(2, "0") +
    "/" +
    String(date.getDate()).padStart(2, "0") +
    "/" +
    date.getFullYear()
  );
};
